import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet-routing-machine";
import { useMap, Polyline, Marker, Popup } from "react-leaflet";
import defaultIcon from "../../assets/icons/ic_location_dot.png";

export const RoutingLocation = ({ 
  from, 
  iconFrom, 
  popupFrom,
  to, 
  iconTo,
  popupTo,
  lineColor = "#4F46E5",
  iconSize = [40, 40], // TAMBAHAN: Ukuran default ikon [lebar, tinggi]
}) => {
  const map = useMap();
  const routingRef = useRef(null);
  const polylineRef = useRef(null); 
  const [isRoutingActive, setIsRoutingActive] = useState(false);

  // Fungsi createIcon yang menggunakan iconSize dari props
  const createIcon = (url) => L.icon({
    iconUrl: url || defaultIcon,
    iconSize: iconSize, 
    // Hitung anchor agar ujung bawah ikon berada tepat di koordinat
    iconAnchor: [iconSize[0] / 2, iconSize[1]], 
  });

  useEffect(() => {
    if (!map || !from || !to || !isRoutingActive) {
      if (routingRef.current) {
        map.removeControl(routingRef.current);
        routingRef.current = null;
      }
      return;
    }

    const control = L.Routing.control({
      waypoints: [
        L.latLng(from.lat, from.lng),
        L.latLng(to.lat, to.lng),
      ],
      addWaypoints: false,
      draggableWaypoints: false,
      show: false,
      lineOptions: {
        styles: [{ 
          color: lineColor, 
          weight: 6, 
          opacity: 0.8,
          dashArray: '5, 10',
        }],
      },
      createMarker: (i, wp) => {
        // Menggunakan iconSize yang sama untuk marker routing
        const marker = L.marker(wp.latLng, { icon: createIcon(i === 0 ? iconFrom : iconTo) });
        if (i === 0 && popupFrom) marker.bindPopup(popupFrom);
        if (i === 1 && popupTo) marker.bindPopup(popupTo);
        return marker;
      },
    }).addTo(map);

    routingRef.current = control;

    return () => {
      if (routingRef.current) {
        try { map.removeControl(routingRef.current); } catch (e) {}
        routingRef.current = null;
      }
    };
  }, [map, from, to, isRoutingActive, lineColor, iconSize]); // Tambahkan iconSize ke dependency

  // Force Animation
  useEffect(() => {
    if (polylineRef.current) {
      const pathElement = polylineRef.current._path; 
      if (pathElement) {
        pathElement.classList.add('force-dash-animation');
        pathElement.style.strokeDasharray = "15, 10";
      }
    }
  }, [polylineRef]);

  if (isRoutingActive) return null;

  return (
    <>
      <style>{`
        .force-dash-animation {
          animation: moveDash 2s linear infinite;
        }
        @keyframes moveDash {
          to {
            stroke-dashoffset: -25; 
          }
        }
      `}</style>

      <Polyline 
        ref={polylineRef}
        positions={[[from.lat, from.lng], [to.lat, to.lng]]} 
        pathOptions={{ 
          color: lineColor, 
          weight: 4, 
          opacity: 0.8,
          dashArray: '15, 10', 
        }}
        eventHandlers={{
          click: () => setIsRoutingActive(true),
        }}
      />
      
      {/* Marker 'From' */}
      <Marker position={[from.lat, from.lng]} icon={createIcon(iconFrom)}>
        {popupFrom && <Popup>{popupFrom}</Popup>}
      </Marker>
      
      {/* Marker 'To' */}
      <Marker position={[to.lat, to.lng]} icon={createIcon(iconTo)}>
        {popupTo && <Popup>{popupTo}</Popup>}
      </Marker>
    </>
  );
};